export const en = {
  // actions
  "action.archive": "Archive",
  "action.cancel": "Cancel",
  "shortcuts.title": "Keyboard shortcuts",
  "shortcuts.search": "Search everything",
  "shortcuts.send": "Send message",
  "shortcuts.newline": "New line",
  "shortcuts.slash": "Prompt templates (type / first)",
  "shortcuts.accept": "Accept suggestion",
  "shortcuts.close": "Close / cancel",
  "shortcuts.help": "Show this list",
  "export.title": "Download this chat (Markdown)",
  "export.you": "You",
  "quick.label": "Quick follow-ups",
  "quick.shorter": "Shorter",
  "quick.shorter.prompt": "Make that shorter.",
  "quick.simpler": "Simpler",
  "quick.simpler.prompt": "Explain that more simply.",
  "quick.more": "More detail",
  "quick.more.prompt": "Go deeper with more detail and examples.",
  "quick.translate": "Translate",
  "quick.translate.prompt": "Translate that to the other language (Arabic ↔ English).",
  "quick.continue": "Continue",
  "quick.continue.prompt": "Continue.",
  "slash.summarize": "Summarize in bullets",
  "slash.translate": "Translate",
  "slash.explain": "Explain simply",
  "slash.eli5": "Explain like I'm five",
  "slash.fix": "Find and fix a bug",
  "slash.shorten": "Make shorter",
  "slash.expand": "Expand",
  "slash.proofread": "Proofread",
  "slash.email": "Professional email",
  "slash.table": "Turn into a table",
  "slash.plan": "Step-by-step plan",
  "slash.formula": "Excel formula",
  "slash.sql": "SQL query",
  "slash.prompt": "Improve a prompt",
  "crash.title": "Something went wrong",
  "crash.body":
    "This page crashed, but your chats are safe. Reload to continue; copy the details if you want to report it.",
  "crash.reload": "Reload",
  "crash.copy": "Copy details",
  "status.title": "System status",
  "status.hint": "Live health of the database and storage (owner only).",
  "status.error": "Could not read the status.",
  "status.db": "Database",
  "status.kv": "Storage (KV)",
  "status.providers": "Providers on",
  "status.totals": "{users} users · {conversations} chats · {messages} messages",
  "status.refresh": "Refresh",
  "focus.exit": "Exit focus mode",
  "shortcuts.focus": "Focus mode (only the chat)",
  "greet.night": "Up late, {name}?",
  "greet.morning": "Good morning, {name}",
  "greet.afternoon": "Good afternoon, {name}",
  "greet.evening": "Good evening, {name}",
  "interface.ambient": "Ambient aurora background",
  "interface.ambientHint":
    "A slow, soft glow drifting behind the app. Off by default; never runs when reduced motion is on.",
  "data.title": "Your data",
  "data.hint":
    "Download every chat as one file, or bring your history in from ChatGPT, Claude or a previous QN AI export (conversations.json).",
  "data.export": "Download all chats",
  "data.import": "Import chats",
  "data.exported": "Downloaded.",
  "data.noChats": "No chats found in that file.",
  "data.progress": "Importing… {done} / {total}",
  "data.imported": "Imported {chats} chats ({messages} messages).",
  "status.dbSize": "Database size",
  "status.cleanup":
    "Last cleanup {when}: removed {n} old rows (expired sessions, old notifications, audit and job history, orphan search entries). Runs daily at 03:17 UTC; chats are never touched.",
  "status.cleanNow": "Clean up now",
  "palette.contrast": "High contrast",
  "general.extraLarge": "Extra large",
  "sidebar.title": "Chats and navigation",
  "settings.sections": "Settings sections",
  "a11y.skip": "Skip to content",
  "a11y.replyDone": "The reply is ready.",
  "feedback.good": "Good answer",
  "feedback.bad": "Bad answer",
  "feedback.why": "What was wrong?",
  "feedback.reason.wrong": "Wrong",
  "feedback.reason.too_long": "Too long",
  "feedback.reason.language": "Language / dialect",
  "feedback.reason.slow": "Slow",
  "feedback.reason.unsafe": "Unsafe",
  "feedback.reason.other": "Other",
  "incidents.title": "Incidents and answer quality",
  "incidents.hint":
    "Errors the system saw, grouped, each with a suggested fix. They also feed its learning. Models are ranked by your thumbs.",
  "incidents.none": "No open incidents. 🎉",
  "incidents.resolve": "Resolved",
  "incidents.ignore": "Ignore",
  "incidents.satisfaction": "Satisfaction by model",
  "learning.title": "Learning loop",
  "learning.hint":
    "Every week (or when you press the button) the system reviews feedback and incidents and proposes small lessons. Accepted lessons are added to the assistant's guidance. It never changes code, keys or permissions by itself.",
  "learning.run": "Review now",
  "learning.accepted": "{n} lessons accepted",
  "learning.last": "last review {when}",
  "learning.none": "Nothing waiting for your decision.",
  "learning.accept": "Accept lesson",
  "learning.noted": "Got it",
  "learning.reject": "Reject",
  "action.copy": "Copy",
  "msg.listen": "Listen",
  "msg.stopListening": "Stop",
  "action.delete": "Delete",
  "action.edit": "Edit",
  "action.pin": "Pin",
  "action.rename": "Rename",
  "action.save": "Save",
  "action.unarchive": "Unarchive",
  "action.unpin": "Unpin",

  // auth
  "auth.tagline": "Your own AI workspace.",
  "auth.firstRun":
    "Welcome! Create the owner account to get started. You can add AI providers right after.",
  "auth.name": "Name",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.passwordHint": "min. 10 characters",
  "auth.signIn": "Sign in",
  "auth.createAccount": "Create account",
  "auth.haveAccount": "Already have an account? Sign in",
  "auth.noAccount": "No account yet? Create one",

  // chat
  "chat.new": "New chat",
  "chat.notFound": "This conversation doesn't exist.",
  "composer.placeholder": "Message AI…",
  "composer.send": "Send",
  "composer.stop": "Stop",
  "composer.think": "Think",
  "composer.disclaimer": "AI can make mistakes. Check important information.",
  "empty.title": "How can I help today?",
  "empty.subtitle": "Ask anything — in Arabic or English.",
  "empty.noModelTitle": "Connect your first model",
  "empty.noModelBody":
    "AI works with any provider: Claude, OpenAI-compatible endpoints (RunPod, Ollama, OpenRouter…) or Workers AI. Add one in a minute.",
  "empty.addModel": "Add a model",
  "suggest.1": "Write a clear weekly status update from my rough notes",
  "suggest.2": "Explain how workforce-management forecasting works",
  "suggest.3": "Draft a formal email to a client about a delivery delay",
  "suggest.4": "Review this code and suggest improvements",

  // messages
  "msg.edit": "Edit message",
  "msg.saveSend": "Save & send",
  "msg.regenerate": "Regenerate",
  "msg.retryWith": "Retry with another model",
  "msg.thinking": "Thinking…",
  "msg.thoughts": "Thoughts",
  "msg.stopped": "Stopped.",
  "msg.details": "Details (model, tokens)",
  "msg.empty": "No content.",
  "msg.error": "Something went wrong.",
  "msg.fallbackSummary":
    "Tried another model ({n}x): the first ones were busy or out of quota. Tap for details.",
  "msg.fallback": "{from} failed ({reason}). Switched to {to}.",

  // model picker
  "model.pick": "Choose model",
  "model.select": "Select a model",
  "model.auto": "Auto",
  "model.autoHint":
    "Picks the best model for each message: fast for quick questions, the strongest for hard or long ones, vision for images, and agent mode when tools are needed.",
  "model.autoLast": "Last: {model} ({why})",
  "model.why.quick": "quick question",
  "model.why.normal": "normal question",
  "model.why.hard": "needs analysis",
  "model.why.code": "code",
  "model.why.long": "long request",
  "model.why.tools": "needs tools",
  "model.why.vision": "has an image",
  "model.tier.top": "Strongest",
  "model.tier.balanced": "Balanced",
  "model.tier.light": "Fast & light",
  "model.speed": "Speed",
  "model.none": "No models yet — add a provider in Settings",
  "model.vision": "Vision",
  "model.thinking": "Thinking",
  "model.tools": "Tools",

  // sidebar
  "sidebar.search": "Search chats",
  "sidebar.history": "Chat history",
  "sidebar.empty": "No chats yet",
  "sidebar.noResults": "No matching chats",
  "sidebar.noArchived": "No archived chats",
  "sidebar.options": "Chat options",
  "sidebar.settings": "Settings",
  "sidebar.toggle": "Toggle sidebar",
  "sidebar.showArchived": "Show archived",
  "sidebar.hideArchived": "Hide archived",
  "sidebar.deleteTitle": "Delete this chat?",
  "sidebar.deleteBody": "The conversation and all its messages will be permanently deleted.",
  "group.pinned": "Pinned",
  "group.today": "Today",
  "group.yesterday": "Yesterday",
  "group.week": "Previous 7 days",
  "group.older": "Older",

  // settings shell
  "settings.title": "Settings",
  "settings.back": "Back to chat",
  "settings.profile": "Profile",
  "settings.general": "General",
  "settings.waterfall": "Waterfall (model order)",
  "wf.intro":
    "When a model fails or is slow, the app moves to the next one in this list automatically. The order depends on the kind of request: quick questions fall back through fast models, hard ones through the strongest. Auto mode picks the first model per message.",
  "wf.kind": "Kind of request",
  "wf.kind.fast": "Quick chat",
  "wf.kind.balanced": "Normal",
  "wf.kind.power": "Hard / code / long",
  "wf.kind.agent": "Agent (tools)",
  "wf.kind.vision": "With images",
  "wf.kind.fast.hint": "Short questions and greetings: fastest capable models first.",
  "wf.kind.balanced.hint": "Everyday requests: a balance of quality and speed.",
  "wf.kind.power.hint": "Analysis, code, long or demanding requests: strongest models first.",
  "wf.kind.agent.hint":
    "Documents, connected accounts, running code: only models that support tools, strongest first.",
  "wf.kind.vision.hint": "Messages with images: only models that can see images.",
  "wf.on": "Waterfall on",
  "wf.off": "Waterfall off (no failover)",
  "wf.auto": "Automatic order",
  "wf.manual": "Manual order",
  "wf.freeOnly": "Free only",
  "wf.allowPaid": "Paid allowed after free",
  "wf.adaptive": "Adapts to real success rates",
  "wf.edit": "Change settings",
  "wf.manualNote":
    "You set a manual chain in Models & Providers; it is used when the primary model fails. The list below is what Automatic order would use.",
  "wf.order": "Order",
  "wf.orderHint":
    "The first model answers; if it fails before replying, the next is tried (up to {n} fallbacks). Dimmed rows are beyond that limit.",
  "wf.empty":
    "No usable models for this kind of request. Add a provider key or enable a provider in Models & Providers.",
  "wf.health": "Provider health (last check)",
  "wf.noData": "no data",
  "wf.strength": "Strength",
  "wf.legend":
    "Bar = capability estimate · ⚡ = speed · eye = vision · brain = reasoning · wrench = tools · % = real success rate on this instance.",
  "settings.models": "Models & Providers",
  "settings.security": "Security",
  "settings.about": "About",

  // general
  "general.appearance": "Appearance",
  "general.language": "Language",
  "general.theme": "Theme",
  "general.dark": "Dark",
  "general.light": "Light",
  "general.system": "System",
  "general.accent": "Accent color",
  "general.accentHint": "Used for buttons, highlights and the logo.",
  "general.customColor": "Custom color",
  "general.density": "Density",
  "general.comfortable": "Comfortable",
  "general.compact": "Compact",
  "general.fontSize": "Text size",
  "general.small": "Small",
  "general.medium": "Medium",
  "general.large": "Large",
  "general.instructions": "Custom instructions",
  "general.instructionsHint":
    "Added to every conversation. Tell AI about your role, tone, and preferences.",
  "general.instructionsPlaceholder":
    "e.g. I'm a WFM analyst. Prefer concise answers with tables. Reply in Egyptian Arabic when I write in Arabic.",

  // profile / security
  "profile.account": "Account",
  "profile.signOut": "Sign out",
  "profile.signOutHint": "Sign out of this device.",
  "security.password": "Change password",
  "security.passwordHint": "Changing your password signs you out everywhere else.",
  "security.current": "Current password",
  "security.new": "New password",
  "security.changed": "Password updated.",
  "security.sessions": "Active sessions",
  "security.sessionsHint": "Devices currently signed in to your account.",
  "security.current_badge": "This device",
  "security.revoke": "Sign out",
  "about.body":
    "AI is a self-owned AI assistant. Models are plug-and-play: change the provider in Settings → Models & Providers, no code changes needed.",

  // models
  "models.intro":
    "Connect any model provider. Keys are encrypted at rest and never shown again after saving.",
  "models.add": "Add provider",
  "models.edit": "Edit provider",
  "models.emptyTitle": "No providers yet",
  "models.emptyHint":
    "Add Claude, an OpenAI-compatible endpoint (RunPod, Ollama, OpenRouter, DeepSeek…) or Workers AI.",
  "models.keySaved": "Key saved",
  "models.noKey": "No key",
  "models.enabled": "Enabled",
  "models.moveUp": "Move up",
  "models.moveDown": "Move down",
  "models.refresh": "Update models list",
  "models.refreshing": "Checking…",
  "models.refreshed": "Models updated: {total} available, {added} new, {removed} retired.",
  "billing.yes": "May charge you",
  "billing.maybe": "Free allowance, then billed",
  "billing.reason.paid": "this provider is paid.",
  "billing.reason.credits": "free credits/allowance only; usage beyond it is billed.",
  "billing.reason.card": "API access needs a payment method before it works.",
  "billing.reason.upgrade": "the free plan could not activate API keys; upgrading is paid.",
  "billing.reason.workers": "free daily allowance, then billed to your Cloudflare account.",
  "usage.today": "Today",
  "usage.month": "this month",
  "usage.requests": "requests",
  "usage.tokens": "tokens",
  "usage.usedOf": "used {used} of {total}",
  "usage.reportedAt": "Quota reported by the provider at {time} (updates after each call).",
  "models.viewMore": "View more (+{n})",
  "models.viewLess": "Show less",
  "models.probe": "Test all models",
  "models.probing": "Testing models… (up to a minute)",
  "models.probeConfirm":
    "This sends a tiny request to each model (uses a few free tokens), removes the ones that do not work for your account and marks which support tools. Continue?",
  "models.probed": "{working} of {probed} models work · {tools} support tools · {removed} removed.",
  "models.test": "Test connection",
  "models.testOk": "OK · {ms} ms · {model}",
  "models.deleteTitle": "Delete provider?",
  "models.deleteBody":
    "“{name}” and its stored key will be removed. Chats using it will need another model.",
  "models.formHint": "Pick a preset to prefill, then add your API key.",
  "models.preset": "Start from a preset",
  "models.presetPick": "Choose a preset…",
  "models.name": "Display name",
  "models.type": "Provider type",
  "models.baseUrl": "Base URL",
  "models.baseUrlHint": "https only (http allowed for localhost)",
  "models.accountId": "Cloudflare account ID",
  "models.apiKey": "API key",
  "models.instructions": "Direction prompt (this provider only)",
  "models.instructionsPh":
    "e.g. Always answer in the user's language. Never output Chinese characters unless asked…",
  "models.instructionsNote":
    "Added to the system prompt of every request sent to THIS provider only. Other providers are not affected. Keep it short for small local models.",
  "models.keyKeep": "leave empty to keep the saved key",
  "models.keyNote": "Stored encrypted (AES-GCM). It is never sent back to your browser.",
  "models.keyRemove": "Remove the saved key",
  "models.models": "Models",
  "models.modelId": "Model ID",
  "models.priceIn": "$/1M input",
  "models.priceOut": "$/1M output",
  "models.addModel": "Add model",
  "models.priceNote": "Prices are optional and power the cost tracking.",
  "models.capabilities": "Capabilities",
  "models.maxContext": "Context window (tokens)",
  "cap.tools": "Tool calling",
  "cap.vision": "Vision",
  "cap.thinking": "Thinking",
  "cap.audio": "Audio",
  "cap.promptCaching": "Prompt caching",

  // routing
  "routing.title": "Default model & fallback",
  "routing.hint":
    "If the chosen model fails before answering, AI automatically tries the next one in this chain.",
  "routing.default": "Default model for new chats",
  "routing.firstAvailable": "First available",
  "routing.chain": "Fallback chain",
  "routing.chainEmpty":
    "No fallback configured. Add models below to stay online if a provider fails.",
  "routing.addToChain": "Add a fallback model…",
  // agent
  "composer.agent": "Agent",
  "composer.plan": "Plan",
  "composer.planHint": "Plan mode: the agent proposes a plan and cannot run side-effecting tools",
  "agent.sandboxOffline": "Sandbox offline",
  "agent.sandboxOfflineHint":
    "No Raspberry Pi runner is connected. Web search/fetch still work; code execution and files do not.",
  "agent.needsApproval": "Needs approval",
  "agent.result": "Result",
  "agent.approvalTitle": "The agent wants to run:",
  "agent.approve": "Approve",
  "agent.deny": "Deny",
  "agent.always": "Always allow in this chat",
  "agent.progress": "Progress",
  "agent.working": "Working…",
  "agent.interrupted": "This run was interrupted (the server restarted). You can resume it.",
  "agent.resume": "Resume",
  "settings.tools": "Tools & Permissions",
  "settings.runner": "Runner (Pi)",
  "tools.search": "Web search",
  "tools.searchHint":
    "Agents search the web through the provider you choose. Your key is stored encrypted and never shown again.",
  "tools.notConfigured": "Not configured",
  "tools.provider": "Provider",
  "tools.permissions": "Tool permissions",
  "tools.permissionsHint":
    "Ask = confirm each time · Allow = run automatically · Deny = never. You can also allow a tool just for one chat from the approval prompt.",
  "tools.runnerOffline":
    "No runner is online: sandbox tools are unavailable. Pair your Raspberry Pi in Settings → Runner.",
  "tools.ask": "Ask",
  "tools.allow": "Allow",
  "tools.deny": "Deny",
  "runner.intro":
    "The runner is a small service on your Raspberry Pi that executes code and file tools inside throw-away Docker sandboxes. It connects out to this app — nothing is exposed on your network. Without it, the app still works (chat, web search, files generation) but code execution is unavailable.",
  "runner.status": "Connected runners",
  "runner.online": "online",
  "runner.offline": "offline",
  "runner.noneTitle": "No runner paired",
  "runner.noneHint": "Generate a pairing code below and run one command on the Pi.",
  "runner.pairTitle": "Pair a Raspberry Pi",
  "runner.pairHint":
    "Run the command on the Pi (Raspberry Pi OS 64-bit, with your HDD mounted). It installs Docker if needed, builds the sandbox, and starts the runner.",
  "runner.switchTitle": "Use the code sandbox",
  "runner.switchHint":
    "Turns the sandbox tools (Python, shell, files) on or off for Agent mode. The runner keeps running on your device; stop or remove it with the commands below.",
  "runner.switchOn": "On - Agent can run code",
  "runner.switchOff": "Off - code tools are hidden from Agent",
  "runner.haTitle": "Home Assistant / command cheat sheet",
  "runner.haHint":
    "Run these in the Advanced SSH & Web Terminal add-on (Protection mode OFF). Generate a pairing code above first; it is filled in below.",
  "runner.haEnable": "Enable / pair (replace XXXX-XXXX with a fresh code)",
  "runner.haLocalAi":
    "Enable + local AI that works with no internet (picks a small model for your RAM and disk)",
  "runner.haRestartAi": "Start again after a reboot (with the local AI)",
  "runner.haRestart": "Start it again (after a reboot)",
  "runner.haStop": "Stop it",
  "runner.haRemove": "Remove it completely",
  "runner.haNote":
    "After removing the runner, turn Protection mode back ON in the add-on. On a normal Raspberry Pi use the install command from the pairing section instead.",
  "runner.generate": "Generate pairing command",
  "runner.runOnPi": "Run on the Raspberry Pi:",
  "runner.codeExpires": "The code works once and expires in 15 minutes.",
  // phase 3
  "composer.attach": "Attach files or images",
  "composer.uploading": "Uploading…",
  "composer.lookAttached": "Please look at the attached file(s).",
  "nav.artifacts": "Artifacts",
  "artifacts.emptyTitle": "No artifacts yet",
  "artifacts.emptyHint":
    "Ask AI in Agent mode to create a document, spreadsheet, presentation, web page, diagram or code file — it appears here.",
  "artifact.panel": "Artifact",
  "artifact.untitled": "Untitled",
  "artifact.updated": "Updated artifact",
  "artifact.failed": "Could not create artifact",
  "voice.title": "Voice mode",
  "voice.listening": "Listening…",
  "voice.hearing": "Hearing you…",
  "voice.transcribing": "Transcribing…",
  "voice.thinking": "Thinking…",
  "voice.gemini": "Natural voice (Gemini, free)",
  "voice.geminiHint":
    "Uses your Google Gemini key (free tier) to speak with a much more natural, dialect-matched voice (Egyptian, Saudi, Gulf, Levantine…). If it is unavailable or its daily free allowance is used up, the voice above takes over automatically.",
  "voice.readAloud": "Read replies aloud",
  "voice.repliesVoice": "Replies: voice",
  "voice.repliesText": "Replies: text",
  "voice.speaking": "Speaking… (tap to interrupt)",
  "voice.muted": "Microphone muted",
  "voice.mute": "Mute",
  "voice.unmute": "Unmute",
  "voice.end": "End",
  "voice.noMic": "Could not access the microphone",
  "voice.unsupported":
    "Speech recognition isn't available in this browser — pick a server option in Settings → Voice",
  "voice.dictate": "Dictate",
  "voice.stopDictation": "Stop dictation",
  "settings.voice": "Voice",
  "voice.settings.sttSpeechOnly":
    "The provider you selected for speech-to-text only speaks (it cannot transcribe). The built-in Whisper is used instead; pick Workers AI or another provider to remove this warning.",
  "voice.settings.stt": "Speech-to-text (your voice → text)",
  "voice.settings.tts": "Text-to-speech (answers read aloud)",
  "voice.settings.lang": "Language",
  "voice.settings.langAuto": "Auto (follow interface language)",
  "voice.settings.src.browser": "This browser (free, no server)",
  "voice.settings.src.workers-ai": "Workers AI Whisper",
  "voice.settings.src.provider": "A provider / my Pi voice server",
  "voice.settings.provider": "Provider",
  "voice.settings.providerNone": "— choose —",
  "voice.settings.model": "Model",
  "voice.settings.voice": "Voice name",
  "voice.settings.piHint":
    "On the Pi: add a provider with Base URL runner://voice/v1 (Settings → Models) after running the installer with the voice profile.",
  "voice.settings.testSpeak": "Test voice",
  "voice.settings.testing": "Playing…",
  "voice.settings.sample": "Hello! This is AI speaking.",
  "voice.settings.sampleAr": "أهلاً! أنا AI.",
  "voice.settings.saved": "Saved",
  "voice.settings.workersAiOff": "Workers AI isn't available on this deployment.",
  "voice.settings.runnerOffline": "Your Pi runner is offline.",
  "cost.free": "Free",
  "cost.quota": "Free quota, then paid",
  "cost.paid": "Paid",
  "cost.label": "Cost",
  "cost.freeHint": "No charge (free tier or self-hosted)",
  "cost.quotaHint": "Free allowance first, then billed to your account",
  "cost.paidHint": "Costs money per use (or the cost is unknown)",
  "models.getKey": "Get a free key ↗",
  "routing.waterfall": "Waterfall failover",
  "routing.waterfallHint":
    "If a model fails or runs out before answering, try the next one automatically.",
  "routing.mode": "Order",
  "routing.mode.auto": "Automatic",
  "routing.mode.auto.hint": "Every available model, strongest first.",
  "routing.mode.manual": "Manual",
  "routing.mode.manual.hint": "Only the models you pick, in the order you set.",
  "routing.freeOnly": "Free models only",
  "routing.freeOnlyHint": "Never fall back to a model that costs money.",
  "routing.paidWarning": "Warning: with this off, failover may use paid models and spend money.",
  "routing.effective": "Order that will be tried after your chosen model",
  "routing.effectiveEmpty": "No other models yet. Add free providers above to build the waterfall.",
  "routing.sortByStrength": "Sort strongest first",
  "routing.up": "Move up",
  "routing.down": "Move down",
  "toggle.language": "Switch language",
  "toggle.light": "Switch to light theme",
  "toggle.dark": "Switch to dark theme",
  "auth.passkey": "Sign in with fingerprint / passkey",
  "passkeys.title": "Passkeys (fingerprint, face, device PIN)",
  "passkeys.hint":
    "Sign in with your device's biometrics instead of a password. A passkey also counts as a second factor. Register it on the address you actually use (a passkey is tied to the website address).",
  "passkeys.unsupported": "This browser or device does not support passkeys.",
  "passkeys.add": "Add a passkey",
  "passkeys.namePlaceholder": "Name (e.g. My phone)",
  "passkeys.synced": "synced across your devices",
  "passkeys.used": "Used",
  "instance.title": "Accounts & access (owner)",
  "instance.hint": "These settings apply to everyone who uses this installation.",
  "instance.signup": "Allow new sign-ups",
  "instance.signupHint":
    "Off: only existing accounts can sign in. On: anyone with the link can create an account.",
  "instance.require2fa": "Require a second factor for everyone",
  "instance.require2faHint":
    "Every account must use an authenticator app or a passkey. Accounts without one are asked to set it up before using the app.",
  "require2fa.title": "Secure your account",
  "require2fa.body":
    "The owner requires a second step to sign in. Add a passkey (fingerprint / face / PIN) or an authenticator app to continue.",
  "require2fa.done": "I've set it up — continue",
  "quota.title": "Workers AI daily quota",
  "quota.source.cloudflare": "Exact (Cloudflare)",
  "quota.source.cloudflare.hint": "Read from Cloudflare analytics for your whole account",
  "quota.source.estimate": "Estimate",
  "quota.source.estimate.hint":
    "Calculated from this app's own usage. Add CF_ACCOUNT_ID and CF_ANALYTICS_TOKEN to the Worker for exact account-wide numbers.",
  "quota.paused": "Auto-paused",
  "quota.used": "Used today (neurons)",
  "quota.remaining": "Remaining",
  "quota.limit": "Your daily limit",
  "quota.day": "day",
  "quota.resets": "Resets",
  "quota.resetsHint": "Resets every day at 00:00 UTC ({time} your time)",
  "quota.in": "in {left}",
  "quota.free":
    "Free allowance: {n} neurons per day, then {rate} per 1,000 neurons billed to your Cloudflare account.",
  "quota.overage": "Over the free allowance by {n} neurons today — about {usd} will be billed.",
  "quota.guard": "Auto switch-off",
  "quota.guardHint":
    "Pause Workers AI automatically at {pct}% of your daily limit (back after the reset).",
  "quota.threshold": "Switch off at",
  "quota.dailyLimit": "Daily limit (neurons)",
  "quota.limitHint":
    "The daily limit defaults to the free 10,000 neurons. Raising it allows paid usage — keep it at the free amount to never pay.",
  "quickkey.title": "Needs a free key to start",
  "quickkey.hint":
    "Create a free account at the provider, copy the API key and paste it here. Until then the waterfall skips this provider.",
  "quickkey.placeholder": "Paste the API key",
  "quickkey.needsKey": "Needs a key",
  "settings.system": "Users & access",
  "settings.systemGroup": "System (owner only)",
  "users.title": "Users",
  "users.hint":
    "Everyone with an account on this installation. Only you (the owner) see this page.",
  "users.owner": "Owner",
  "users.user": "User",
  "users.disabled": "Blocked",
  "users.has2fa": "2-step on",
  "users.no2fa": "No 2-step",
  "users.joined": "joined",
  "users.lastLogin": "last sign-in",
  "users.disable": "Block",
  "users.enable": "Unblock",
  "users.reset2fa": "Reset 2-step",
  "users.deleteTitle": "Delete this user?",
  "users.deleteBody":
    "{name} and all their chats, files and providers will be permanently deleted.",
  "users.stat.total": "Accounts",
  "users.stat.online": "Online now",
  "users.stat.24h": "Active (24 h)",
  "users.stat.7d": "Active (7 days)",
  "users.stat.30d": "Active (30 days)",
  "users.stat.active": "Not blocked",
  "users.stat.disabled": "Blocked",
  "users.stat.no2fa": "Without 2-step",
  "users.online": "Online now",
  "users.offline": "Offline",
  "users.seen": "last seen",
  "users.chats": "chats",
  "users.tokens": "tokens this month",
  "users.activity": "Activity",
  "users.devices": "Devices & sessions",
  "users.noSessions": "No active sessions",
  "users.events": "Recent events",
  "general.black": "Black (neutral)",
  "general.themeHint":
    "Each background brings its own accent colour; pick your own below to override it.",
  "palette.qn": "QN (house)",
  "palette.dark": "Midnight",
  "palette.black": "Black",
  "palette.graphite": "Graphite",
  "palette.warm": "Warm",
  "palette.forest": "Forest",
  "palette.ocean": "Ocean",
  "palette.wine": "Wine",
  "palette.aurora": "Aurora",
  "palette.neon": "Neon",
  "palette.sunrise": "Sunrise",
  "palette.light": "Light",
  "palette.paper": "Paper",
  "palette.mist": "Mist",
  "replies.title": "How the AI replies",
  "replies.hint": "Applies to every chat and agent run.",
  "replies.language": "Reply language / dialect",
  "replies.languageHint": "Auto = answer in whatever language and dialect you write in.",
  "replies.lang.auto": "Auto (mirror me)",
  "replies.lang.ar-eg": "Egyptian Arabic (colloquial)",
  "replies.lang.ar-baladi": "Egyptian baladi",
  "replies.lang.ar-saidi": "Saidi (Upper Egypt)",
  "replies.lang.ar-levant": "Levantine Arabic",
  "replies.lang.ar-gulf": "Gulf Arabic",
  "replies.lang.ar-maghreb": "Maghrebi Arabic (Darija)",
  "replies.lang.ar-fusha": "Modern Standard Arabic",
  "replies.lang.en": "English",
  "replies.lang.fr": "French",
  "replies.lang.es": "Spanish",
  "replies.lang.de": "German",
  "replies.lang.tr": "Turkish",
  "replies.tone": "Tone",
  "replies.tone.balanced": "Balanced",
  "replies.tone.concise": "Short and direct",
  "replies.tone.detailed": "Detailed",
  "replies.tone.friendly": "Friendly",
  "replies.tone.formal": "Formal",
  "replies.emoji": "Allow emoji in replies",
  "replies.emojiHint": "Off by default for a more professional look.",
  "interface.title": "Interface",
  "interface.sendOnEnter": "Send with Enter",
  "interface.sendOnEnterHint": "Off: Enter adds a new line and Ctrl/Cmd+Enter sends.",
  "interface.width": "Chat width",
  "interface.width.narrow": "Narrow",
  "interface.width.normal": "Normal",
  "interface.width.wide": "Wide",
  "interface.font": "Reading font",
  "interface.font.sans": "Sans-serif",
  "interface.font.serif": "Serif",
  "interface.font.mono": "Monospace",
  "interface.reduceMotion": "Reduce motion",
  "interface.showUsage": "Show tokens and cost under replies",
  "interface.showUsageHint": "Per-message usage line.",
  "suggest.fromHistory": "Based on your recent prompts — change this in Settings → General.",
  "suggest.listLabel": "Suggestions",
  "suggest.hint": "Tab to accept · ↑↓ to choose · Esc to close",
  "suggest.title": "Suggestions",
  "suggest.settingsHint":
    "Starters on the empty chat screen and Google-style completion while you type.",
  "suggest.starters": "Starters from my history",
  "suggest.startersHint": "Show my recent prompts instead of fixed examples.",
  "suggest.autocomplete": "Autocomplete while typing",
  "suggest.autocompleteHint":
    "Finishes your sentence from what you wrote before, in your language and dialect.",
  "suggest.ai": "Smart AI completions",
  "suggest.aiHint":
    "Also asks a free AI model for ideas as you pause (one small model call each time; never a paid model).",
  "suggest.history": "Remember my prompts",
  "suggest.historyHint": "Needed for personalised suggestions. Stored only in your account.",
  "suggest.cleared": "Cleared {n} remembered prompts at {time}.",
  "suggest.nothing": "Nothing to clear - your history is already empty.",
  "suggest.clear": "Clear history",
  "style.title": "Design style",
  "style.modern": "Modern",
  "style.modern.hint": "Soft colour glow, rounded cards — the signature look.",
  "style.classic": "Classic",
  "style.classic.hint": "Flat and calm, like ChatGPT or Claude.",
  "style.glass": "Glass",
  "style.glass.hint": "Translucent, blurred and rounded, like iOS.",
  "defaults.title": "Defaults for everyone",
  "defaults.hint":
    "What every account gets until its owner chooses something different. Empty = the built-in default.",
  "defaults.builtIn": "Built-in default",
  "defaults.on": "On",
  "defaults.off": "Off",
  "defaults.applyAll": "Apply to everyone now",
  "defaults.applyAllHint":
    "Clears everyone's own choices for these settings so all accounts follow the defaults again.",
  "defaults.applied": "Done — {n} account(s) reset to the defaults.",
  "defaults.confirmBody":
    "Every user's own choices for the settings above will be removed. This cannot be undone.",
  "install.button": "Install the app",
  "install.installed": "Installed as an app on this device.",
  "install.hint":
    "You can install this as an app: use your browser's menu → Install / Add to Home Screen.",
  "instance.learn": "Learn from conversations",
  "instance.learnHint":
    "The assistant remembers lasting preferences and corrections (language, dialect, format) from each user's own messages and uses them in later chats. Users can still view and delete their memories.",
  "instance.selfImprove": "Self-improve (adaptive routing)",
  "instance.selfImproveHint":
    "Tracks which models actually succeed on this instance and automatically ranks reliable ones higher in the free waterfall. It never changes code or spends money.",
  "voice.noSignal":
    "I can't hear anything from your microphone. Check the microphone permission and that it isn't muted.",
  "voice.noSpeech": "I didn't catch that — try again a little closer to the microphone.",
  "voice.auto": "Auto-detect dialect",
  "voice.autoHint":
    "Detects the dialect of each reply (Egyptian, Saudi, Levantine, Gulf, Maghrebi, English…) and speaks it with a matching voice.",
  "voice.gender": "Voice",
  "voice.gender.female": "Female",
  "voice.gender.male": "Male",
  "voice.deviceHint":
    "Voices installed on this device. Egyptian voices exist mainly on Android/Chrome and Windows; for a guaranteed Egyptian female voice use Azure Speech below.",
  "voice.azure.title": "Natural voices: Azure Speech (free tier)",
  "voice.azure.hint":
    "Official Microsoft Azure Speech API with 40+ Arabic voices, both genders, every dialect (Egyptian Salma/Shakir, Saudi, Syrian, Lebanese, Gulf, Moroccan…) plus English and more. Create a free Speech resource in the Azure portal and paste its region and key; the key is stored encrypted and never shown again.",
  "voice.azure.region": "Azure region",
  "voice.azure.key": "Azure Speech key",
  "voice.azure.add": "Connect",
  "interface.lockZoom": "Lock zoom (app-like)",
  "interface.lockZoomHint":
    "Blocks pinch and double-tap zoom so the app behaves like a native app. Use Text size above to make text bigger.",
  "update.available": "A new version is available.",
  "update.reload": "Reload",
  "update.check": "Check for updates",
  "update.force": "Force reload",
  "update.latest": "You're on the latest version.",
  "update.auto": "Update automatically when I return to the app",
  "notif.settingsTitle": "Notifications",
  "notif.hint":
    "Get a notification on this device when a long task finishes, even with the app closed.",
  "notif.unsupported":
    "This browser can't show background notifications. In-app notifications (the bell) still work.",
  "notif.device": "Notify this device",
  "notif.iosHint":
    "On iPhone/iPad: Share → Add to Home Screen, then open the app from the Home Screen and turn this on.",
  "notif.master": "Allow background notifications",
  "notif.masterHint": "Applies to all your devices.",
  "notif.runDone": "A task or chat finished",
  "notif.approval": "A tool needs my approval",
  "notif.failures": "A task or schedule failed",
  "notif.test": "Send a test notification",
  "notif.devices": "{n} device(s) connected",
  "notif.testSent": "Sent — it should arrive in a few seconds.",
  "notif.testNone": "Nothing was delivered. Turn on 'Notify this device' first.",
  "voice.issue.noVoice":
    "No voice for this language is installed on your device. iPhone: Settings → Accessibility → Spoken Content → Voices.",
  "voice.issue.noVoiceAr":
    "No Arabic voice is installed on your device. iPhone: Settings → Accessibility → Spoken Content → Voices → Arabic (download one), or connect Azure Speech below for natural Arabic voices.",
  "voice.issue.silent":
    "The device didn't play any sound. Check the silent switch and volume, and that the page was opened from a tap.",
  "upload.drop": "Drop files to attach",
  "upload.dropHint":
    "Excel, PowerPoint, Word, PDF, text, CSV and images — the assistant reads them.",
  "interface.imageSafe": "Image safe mode",
  "interface.imageSafeHint":
    "On: requests containing explicit words are refused and a safe-for-work hint is added. Off: only the image provider's own filter applies (useful for art, anatomy, fashion or medical topics). Sexual content is never generated either way.",
  "composer.image": "Image",
  "mode.title": "What to create",
  "mode.auto": "Auto",
  "mode.auto.hint":
    "The app decides: an image, a document or a normal answer, and switches to a model that can do it.",
  "mode.text": "Text only",
  "mode.text.hint": "Never generates images; every message is a normal chat.",
  "mode.image": "Image",
  "mode.image.hint": "Every message becomes an image (describe what you want).",
  "instance.learnRules": "Learn rules from my instructions",
  "instance.learnRulesHint":
    'When you (the owner) give the assistant a lasting instruction in chat — e.g. "from now on only answer workforce-management questions" — it becomes a rule for every user. You are notified and can switch it off below. It changes behaviour through the system prompt, not the code.',
  "rules.title": "Assistant rules (for all users)",
  "rules.hint":
    "Standing rules added to every user's chats and agent runs. The assistant follows them and declines requests that conflict with them. They guide the model; they are not a hard technical block.",
  "rules.learned": "Learned from your chat",
  "rules.none": "No rules yet. Add one below, or just tell the assistant in chat.",
  "rules.add": "Add rule",
  "rules.placeholder": "e.g. Only answer workforce-management questions.",
  "voice.rt.title": "Live voice (full-duplex)",
  "voice.rt.hint":
    "Talk and interrupt at any moment, like ChatGPT Live. Uses OpenAI Realtime with YOUR OpenAI key: it is paid by OpenAI per minute of conversation (it hangs up after 2 quiet minutes). The conversation is not saved in chat history.",
  "voice.rt.use": "Use live voice when an OpenAI key is available",
  "voice.rt.ready": "OpenAI key found — voice mode will use live voice.",
  "voice.rt.needKey":
    "No OpenAI key yet. Add an OpenAI provider with your API key in Settings → Models and live voice turns on automatically. Until then the free voice mode is used.",
  "voice.rt.badge": "OpenAI Realtime · paid",
  "voice.rt.connecting": "Connecting…",
  "voice.rt.error": "Could not start live voice",
  "signin.title": "Sign-in methods",
  "signin.hint":
    "Let people sign in with Google, Apple, Microsoft (Outlook/Hotmail), GitHub, GitLab or Discord. Create an app in the provider's console, paste its keys here (stored encrypted, never shown again) and switch it on. The buttons appear on the sign-in screen automatically.",
  "signin.on": "On — button shown on the sign-in screen",
  "signin.off": "Configured but switched off",
  "signin.notConfigured": "Not set up yet",
  "signin.fromEnv": "keys come from Worker secrets",
  "signin.setup": "Set up / edit keys",
  "signin.steps":
    "1) Create the app and paste this redirect URL. 2) Copy the Client ID and secret here. 3) Save and switch on.",
  "signin.console": "Open the provider console",
  "signin.redirect": "Redirect URL",
  "signin.copy": "Copy",
  "signin.secretSaved": "Saved (leave empty to keep it)",
  "features.title": "Features (control center)",
  "features.hint":
    "Switch whole features on or off for every user. A switched-off feature is hidden and refused by the server. Your owner account keeps access to its own tools (except agent tools you switch off here).",
  "interface.autoSearch": "Look things up automatically",
  "interface.autoSearchHint":
    'For questions about news, "today" or "latest", the assistant first searches the web (free news + Wikipedia, or your own SearXNG / search key) and answers from the results with sources.',
  "interface.autoSkills": "Expert playbooks",
  "interface.autoSkillsHint":
    "Applies the right expert playbook automatically (web design, clean code, Excel formulas, SQL, security, Arabic/RTL, data charts, WFM maths…) when your request needs it.",
  "interface.imageGen": "Image generator",
  "interface.imageGenHint":
    "Built-in (free, online) or your own server that offers /images/generations (LocalAI, a Stable Diffusion API, DALL·E…). Needed for images in local-only mode.",
  "interface.imageGen.builtin": "Built-in (online)",
  "indep.title": "Independence (home / offline)",
  "indep.hint":
    "See what still depends on the internet or someone else's AI, and forbid it. Everything below can later move onto your own hardware: see docs/HOME-SERVER.md.",
  "indep.localOnly": "Local-only mode",
  "indep.localOnlyHint":
    "Nothing is sent to external AI, APIs or websites: only models on your own network answer, web search uses only your SearXNG, social sign-in, push and cloud voice are refused. If no local model exists, chat will say so.",
  "indep.tokens": "API tokens (OpenAI-compatible endpoint)",
  "indep.tokensHint":
    'Let Home Assistant, scripts or other apps use this assistant (same models and waterfall). Use model "auto" or "providerId::model".',
  "indep.tokenName": "Token name",
  "indep.tokenCreate": "Create token",
  "indep.tokenOnce": "Copy it now - it is shown only once.",
  "indep.searx": "SearXNG address (your own search engine)",
  "indep.searxHint":
    "Self-hosted metasearch with no account or key. Used for automatic web lookups; the only search allowed in local-only mode.",
  "indep.status": "What depends on what (right now)",
  "indep.guide":
    "Local = on your own hardware or browser. External = needs the internet or a company's service. How to move each part home: docs/HOME-SERVER.md.",
  "indep.item.llm": "Language models",
  "indep.item.stt": "Speech to text",
  "indep.item.tts": "Text to speech",
  "indep.item.image": "Image generation",
  "indep.item.search": "Web lookup",
  "indep.item.signin": "Sign-in",
  "indep.item.push": "Push notifications",
  "indep.item.hosting": "Where the app runs",
  "indep.state.local": "Local",
  "indep.state.external": "External",
  "indep.state.mixed": "Mixed",
  "indep.state.off": "Off",
  "artifact.close": "Close panel",
  "artifact.you": "You",
  "artifact.preview": "Preview",
  "artifact.download": "Download",
  "artifact.as": "Download as",
  "artifact.asSource": "Download source file",
  "artifact.share": "Share",
  "artifact.shareHint": "Create a public read-only link anyone can open (no sign-in).",
  "artifact.sharedHint": "Anyone with this link can view the latest version.",
  "artifact.createLink": "Create link",
  "artifact.unshare": "Stop sharing",
  "artifact.restore": "Restore this version",
  "artifact.oldVersion": "Older version",
  "artifact.saveVersion": "Save as new version",
  "artifact.type.html": "Web page",
  "artifact.type.svg": "SVG image",
  "artifact.type.markdown": "Markdown",
  "artifact.type.code": "Code",
  "artifact.type.mermaid": "Diagram",
  "artifact.type.document": "Document",
  "artifact.type.sheet": "Spreadsheet",
  "artifact.type.slides": "Presentation",
  "shared.gone": "This link is no longer available",
  "shared.goneHint": "The owner may have stopped sharing it.",
  "shared.footer": "Shared with AI by QN Ventures",
  // phase 4
  "settings.agents": "Agents",
  "nav.projects": "Projects",
  "agents.pick": "Choose agent",
  "agents.mine": "My agents",
  "agents.intro":
    "Agents are specialists with their own instructions, tools, skills and (optionally) model. The default agent (QN) delegates to the others in parallel.",
  "agents.new": "New agent",
  "agents.edit": "Edit agent",
  "agents.builtin": "Built-in",
  "agents.duplicate": "Duplicate",
  "agents.icon": "Icon",
  "agents.description": "Short description",
  "agents.instructions": "Instructions",
  "agents.instructionsPh": "Who is this agent, how should it work, what must it never do…",
  "agents.model": "Model",
  "agents.inheritModel": "Use the chat's model",
  "agents.tools": "Tools",
  "agents.allTools": "All tools",
  "agents.skills": "Skills",
  "agent.using": "Using",
  "agent.brief": "Brief",
  "agent.report": "Report",
  "projects.new": "New project",
  "projects.newChat": "New chat in project",
  "projects.chats": "Chats",
  "projects.noChats": "No chats yet in this project.",
  "projects.instructionsHint": "applies to every chat in the project",
  "projects.knowledge": "Knowledge",
  "projects.knowledgeHint":
    "Files here are available to every chat in this project (text is extracted and used as reference).",
  "projects.addFiles": "Add files",
  // phase 5
  "settings.memory": "Memory",
  "settings.usage": "Usage & Billing",
  "memory.controls": "Memory",
  "memory.intro":
    "AI can remember facts about you across chats. You see, edit and delete everything it remembers.",
  "memory.enabled": "Use memory",
  "memory.enabledHint": "When off, nothing is recalled or saved.",
  "memory.auto": "Learn automatically",
  "memory.autoHint":
    "After a chat, extract durable facts from what YOU wrote (never from web pages or files).",
  "memory.add": "Add a memory",
  "memory.placeholder": "e.g. I work in workforce management and prefer concise answers",
  "memory.category": "Category",
  "memory.cat.preference": "Preference",
  "memory.cat.fact": "Fact",
  "memory.cat.person": "Person",
  "memory.cat.work": "Work",
  "memory.cat.other": "Other",
  "memory.src.manual": "Added by you",
  "memory.src.auto": "Learned automatically",
  "memory.src.tool": "Saved by the assistant",
  "memory.saved": "What I remember",
  "memory.search": "Search memories",
  "memory.allCats": "All categories",
  "memory.export": "Export",
  "memory.import": "Import",
  "memory.badFile": "That file isn't a valid memory export.",
  "memory.emptyTitle": "Nothing remembered yet",
  "memory.emptyHint": "Memories appear here as you chat, or add one above.",
  "memory.clear": "Forget everything",
  "memory.clearConfirm": "Delete ALL memories? This cannot be undone.",
  "usage.range": "Time range",
  "usage.lastDays": "Last {n} days",
  "usage.cost": "Estimated cost",
  "usage.costHint": "From the prices you set per model",
  "usage.calls": "Model calls",
  "usage.input": "Input tokens",
  "usage.output": "Output tokens",
  "usage.perDay": "Tokens per day",
  "usage.none": "No usage in this period.",
  "usage.byModel": "By model",
  "usage.byAgent": "By agent",
  "usage.budget": "Budget",
  "usage.budgetHint":
    "Optional safety limit. When this month's spend reaches it, new messages are paused until you raise or clear it.",
  "usage.monthly": "Monthly limit (USD)",
  "usage.spentMonth": "Spent this month: {v}",
  "usage.noLimit": "No limit",
  "palette.title": "Command palette",
  "palette.placeholder": "Search chats, files, memories… or type a command",
  "palette.agentOn": "Turn Agent mode on",
  "palette.agentOff": "Turn Agent mode off",
  "palette.cycleTheme": "Switch theme (dark / light / system)",
  // phase 6
  "settings.connectors": "Connectors",
  "settings.automations": "Automations",
  "connectors.intro":
    "Connect external tools through MCP (Model Context Protocol). Their tools become available to agents; anything that changes data asks for your approval by default.",
  "connectors.add": "Add connector",
  "connectors.emptyTitle": "No connectors yet",
  "connectors.emptyHint":
    "GitHub, Cloudflare, Supabase, Notion, Slack, Linear — or any MCP server by URL.",
  "connectors.status.connected": "Connected",
  "connectors.status.needs_auth": "Needs authorization",
  "connectors.status.error": "Error",
  "connectors.status.new": "Not checked",
  "connectors.connect": "Connect",
  "connectors.connectContinue": "Continue to authorize",
  "connectors.refresh": "Check & refresh",
  "connectors.toolsCount": "{n} tools",
  "connectors.noTools": "No tools discovered yet. Use “Check & refresh”.",
  "connectors.readOnly": "read-only",
  "connectors.deleteConfirm": "Remove “{name}” and its saved credentials?",
  "connectors.connected": "Connector connected.",
  "connectors.oauthFailed": "Authorization failed ({e}).",
  "connectors.dismiss": "Dismiss",
  "connectors.authType": "Authentication",
  "connectors.token": "Access token",
  "connectors.none": "None",
  "connectors.url": "MCP server URL",
  "auto.intro":
    "Run agents on a schedule or when something calls a webhook. Runs are unattended: tools that need approval pause and notify you.",
  "auto.schedules": "Scheduled tasks",
  "auto.newSchedule": "New schedule",
  "auto.noSchedules": "No scheduled tasks",
  "auto.noSchedulesHint":
    "e.g. every weekday at 08:00: “Summarise yesterday's service level by queue”.",
  "auto.next": "Next",
  "auto.last": "Last",
  "auto.open": "open",
  "auto.runNow": "Run now",
  "auto.webhooks": "Webhooks",
  "auto.webhooksHint":
    "A secret URL that starts an agent run. The request body is given to the agent as untrusted data.",
  "auto.newWebhook": "New webhook",
  "auto.noWebhooks": "No webhooks",
  "auto.hits": "{n} calls",
  "auto.webhookReady": "Webhook created",
  "auto.webhookOnce": "Copy this URL now — it is shown only once.",
  "auto.namePh": "Morning brief",
  "auto.prompt": "What should the agent do?",
  "auto.promptPh": "Summarise yesterday's service level by queue and flag anything below target.",
  "auto.hookPrompt": "Instructions for each call",
  "auto.hookPromptPh": "Triage the incoming alert and propose next steps.",
  "auto.frequency": "Frequency",
  "auto.freq.hourly": "Every hour",
  "auto.freq.daily": "Every day",
  "auto.freq.weekdays": "Weekdays",
  "auto.freq.weekly": "Every week",
  "auto.freq.custom": "Custom (cron)",
  "auto.day": "Day",
  "auto.at": "At",
  "auto.atMinute": "At minute",
  "auto.timezone": "Time zone",
  "auto.defaultAgent": "Default agent (QN)",
  "auto.unattendedNote":
    "Unattended runs can't ask for approval: tools set to “Ask” will pause the run and send you a notification.",
  "auto.create": "Create",
  "notif.title": "Notifications",
  "notif.none": "Nothing yet",
  "notif.markRead": "Mark all read",
  "notif.clear": "Clear",
  "notif.enableDesktop": "Enable desktop alerts",
  // phase 8
  "models.useBinding": "Use the built-in Workers AI binding (no API token needed)",
  "health.healthy": "Healthy",
  "health.degraded": "Degraded",
  "health.down": "Down — skipped",
  "health.unknown": "Not checked",
  // phase 9: security
  "auth.code": "Verification code",
  "auth.codeHint": "6-digit code or a recovery code",
  "auth.or": "or",
  "auth.oauthError": "Sign-in failed ({e}).",
  "twofa.title": "Two-factor authentication",
  "twofa.hint":
    "Require a code from an authenticator app (Google Authenticator, 1Password, Authy…) in addition to your password.",
  "twofa.on": "On — {n} recovery codes left",
  "twofa.off": "Off",
  "twofa.enable": "Enable",
  "twofa.disable": "Disable",
  "twofa.setupTitle": "Set up two-factor",
  "twofa.setupHint":
    "Scan the QR code with your authenticator app, then enter the 6-digit code it shows.",
  "twofa.confirm": "Verify and enable",
  "twofa.codesTitle": "Save your recovery codes",
  "twofa.codesHint": "Each code works once if you lose your device. They are shown only now.",
  "twofa.saved": "I saved them",
  "offline.banner": "You're offline — showing saved chats. New messages need a connection.",
  "backup.title": "Backups to your Pi",
  "backup.hint":
    "The Pi pulls a full copy of your data (chats, memory, artifacts, files, settings) every night into its HDD and keeps the last 14. Provider keys stay encrypted.",
  "backup.now": "Back up now",
  "backup.needsRunner": "Pair your Raspberry Pi first.",
  "evolve.title": "Autonomous self-update (experimental)",
  "evolve.off": "OFF — the app can never change itself. This is the default.",
  "evolve.warnTitle": "Danger: read before enabling",
  "evolve.warn1":
    "Turning this on lets the app MERGE a pull request into your repository without you reading it. A merged change is deployed by your deploy workflow.",
  "evolve.warn2":
    "Even with every guardrail below, automated changes can contain bugs. You are responsible for what is merged. Keep this OFF if the app is used by other people or holds data you cannot lose.",
  "evolve.guardTitle": "Guardrails that cannot be turned off from this screen",
  "evolve.g1": "Never edits or deploys code itself — it only merges an existing pull request.",
  "evolve.g2":
    "The pull request must be green on CI for its exact latest commit, mergeable, and target main.",
  "evolve.g3":
    "Only docs, skills, translations, UI and tests can be auto-merged (max {files} files, {lines} lines, tests required for code).",
  "evolve.g4":
    "Database migrations, secrets, sign-in, security, dependencies, deployment files and this feature's own code always need a human.",
  "evolve.g5": "Only when the app is healthy (self-test green). One self-merge per 24 hours.",
  "evolve.g6":
    "After every merge a 30-minute canary runs; 3 failed checks in a row FREEZE self-update and notify you.",
  "evolve.g7":
    "Frozen means no merges until you type a confirmation. Every action is audit-logged. Turning it off resets everything to propose-only.",
  "evolve.enable": "Enable self-update…",
  "evolve.disable": "Disable",
  "evolve.typeToEnable": "To enable, type {phrase}",
  "evolve.mode": "Mode",
  "evolve.propose": "Propose only — evaluate pull requests, you merge",
  "evolve.auto": "Auto-merge approved pull requests…",
  "evolve.typeToAuto": "To allow auto-merge, type {phrase}",
  "evolve.repo": "Repository (owner/name)",
  "evolve.token":
    "GitHub token (write-only, fine-grained: Pull requests + Contents write on this repo only)",
  "evolve.tokenSet": "Token saved (hidden)",
  "evolve.saveToken": "Save token",
  "evolve.removeToken": "Remove token",
  "evolve.pr": "Pull request number",
  "evolve.check": "Check policy",
  "evolve.merge": "Merge now",
  "evolve.verdict.auto": "Eligible for auto-merge",
  "evolve.verdict.human": "Needs a human review",
  "evolve.verdict.blocked": "Blocked by policy",
  "evolve.frozen": "FROZEN: {reason}",
  "evolve.unfreezeType": "To unfreeze, type {phrase}",
  "evolve.unfreeze": "Unfreeze",
  "evolve.freeze": "Freeze now",
  "evolve.health": "Health {score}/100 ({level})",
  "evolve.degraded": "Optional features are paused until the app recovers.",
  "evolve.blockers": "Right now blocked by: {list}",
  "evolve.confirm": "Confirm",
  "signin.supabase.title": "Google via Supabase (no Google Cloud client needed)",
  "signin.supabase.on": "On — the Google button uses your Supabase project",
  "signin.supabase.steps":
    "Use a Supabase project that already has Google enabled. In that project: Authentication → URL Configuration → Redirect URLs → add the address below. Then paste the project URL and its public (publishable) key.",
  "signin.supabase.key": "Publishable / anon key (public)",
  "data.training": "Export training data (👍 answers)",
  "data.trainingNone": "No 👍-rated answers yet. Rate good answers with the thumbs-up first.",
  "data.trainingDone":
    "Exported {n} training samples (JSONL). Keep the file private: it contains your chats.",
  "nav.assistant": "Assistant",
  "assistant.tab.errands": "Tasks",
  "errand.hint":
    "Everything you ask the assistant becomes a task here: what it is waiting for, what people answered, and what needs your decision.",
  "errand.empty": "No open tasks",
  "errand.emptyHint": "Ask the assistant in chat, e.g. “Ask Mohamed when he is free this week”.",
  "errand.showAll": "Show finished tasks too",
  "errand.cancel": "Cancel this task",
  "errand.timeline": "Timeline",
  "errand.status.working": "Working on it",
  "errand.status.waiting": "Waiting for replies",
  "errand.status.needs_you": "Needs you",
  "errand.status.done": "Done",
  "errand.status.cancelled": "Cancelled",
  "errand.kind.created": "Started",
  "errand.kind.linked": "Added",
  "errand.kind.said": "Assistant said",
  "errand.kind.reply": "They replied",
  "errand.kind.needs_you": "Needs you",
  "errand.kind.done": "Done",
  "errand.kind.failed": "Problem",
  "errand.kind.call": "Call",
  "errand.kind.snooze": "Later",
  "errand.kind.cancelled": "Cancelled",
  "assistant.tab.threads": "Conversations",
  "assistant.tab.contacts": "Contacts",
  "assistant.tab.calendar": "Calendar",
  "assistant.tab.channels": "Channels",
  "assistant.back": "Back",
  "assistant.note": "Note",
  "assistant.failed": "not delivered",
  "assistant.sender.assistant": "Assistant",
  "assistant.sender.owner": "You",
  "assistant.sender.contact": "Them",
  "assistant.sender.system": "System",
  "assistant.write": "Write a message…",
  "assistant.requestHint":
    "Write what you want, like asking an assistant. It will say it to them in its own words, as your assistant.",
  "assistant.verbatim": "Send exactly my words",
  "assistant.send": "Send",
  "assistant.close": "Close conversation",
  "assistant.inbox": "Messages for you from other assistants",
  "assistant.noThreads": "No conversations yet",
  "assistant.noThreadsHint":
    "Ask in chat: “Call Mohamed and tell him not to be late”. The assistant contacts them, answers their follow-ups within your request, and reports back here.",
  "assistant.callState.ringing": "Ringing…",
  "assistant.callState.active": "On the call",
  "assistant.callState.ended": "Call ended",
  "assistant.callState.missed": "Missed — I sent a message instead",
  "assistant.callState.declined": "Declined — I sent a message instead",
  "assistant.voicePrefs": "How my assistant sounds, and quiet hours",
  "assistant.voiceGender": "Assistant voice",
  "assistant.female": "Woman",
  "assistant.male": "Man",
  "assistant.quietFrom": "Don't ring me from",
  "assistant.quietTo": "until",
  "assistant.quietHint":
    "Other people's assistants will not ring you during these hours (in your time zone); they leave a message instead. Same hour in both boxes = never block.",
  "telegram.title": "Telegram — talk to your assistant from your phone (free)",
  "telegram.hint":
    "Text your own bot like you would text a person, or send a voice note: it does the task, asks for your approval with buttons before anything sensitive, tells you when someone replies, and can send a morning briefing.",
  "telegram.step1": "In Telegram open @BotFather, send /newbot and follow the 2 questions.",
  "telegram.step2": "Copy the token it gives you and paste it below.",
  "telegram.token": "Bot token",
  "telegram.connect": "Connect",
  "telegram.linked": "your chat is linked",
  "telegram.notLinked": "not linked yet",
  "telegram.getLink": "Link my Telegram",
  "telegram.open": "Open Telegram",
  "telegram.orSend": "or send your bot",
  "telegram.forward": "Tell me here when people reply or runs finish",
  "telegram.briefing": "Morning briefing at",
  "telegram.off": "Off",
  "telegram.disconnect": "Disconnect",
  "assistant.status.waiting": "Waiting for reply",
  "assistant.status.replied": "Replied",
  "assistant.status.escalated": "Needs you",
  "assistant.status.done": "Done",
  "assistant.status.failed": "Failed",
  "assistant.status.closed": "Closed",
  "assistant.addContact": "Add a contact",
  "assistant.name": "Name",
  "assistant.phone": "Phone",
  "assistant.noContacts": "No contacts yet",
  "assistant.noContactsHint":
    "Add a friend with a phone number or e-mail. If they have an account here, they are linked automatically.",
  "assistant.noChannel": "Cannot be reached yet — connect a channel or add a number/e-mail",
  "assistant.shareFree": "Tell them when I'm free",
  "assistant.message": "Message",
  "assistant.channel": "Channel",
  "assistant.autoChannel": "Best channel",
  "assistant.addEvent": "Add an event",
  "assistant.eventTitle": "Title",
  "assistant.start": "Starts",
  "assistant.end": "Ends",
  "assistant.busy": "Busy (next 14 days)",
  "assistant.free": "Free slots in your working hours",
  "assistant.nothing": "Nothing scheduled",
  "assistant.feeds": "Connected calendars",
  "assistant.feedsHint":
    "Paste the link of your calendar (ends with .ics). Outlook.com: Settings → Calendar → Shared calendars → Publish a calendar → pick the calendar, “Can view all details” → Publish → copy the ICS link. Google: Settings → your calendar → Integrate calendar → “Secret address in iCal format”. Read-only; stored encrypted.",
  "assistant.connect": "Connect",
  "assistant.shares": "Share your free/busy with other accounts",
  "assistant.sharesHint":
    "They see only when you are busy, never titles. Their assistant can use it when planning with you.",
  "assistant.stopShare": "Stop sharing",
  "assistant.share": "Share",
  "assistant.sharedWithMe": "Shared with you by: {names}",
  "assistant.channelsHint":
    "The assistant can message people in this app for free. To reach people outside it, connect your own accounts below (you pay your provider directly; keys are stored encrypted and never shown again).",
  "assistant.calls": "calls",
  "assistant.connected": "Connected",
  "assistant.twilioHook":
    "In Twilio set these webhooks so replies and call answers reach the assistant: messaging “A message comes in” → SMS URL; the phone number’s voice is configured automatically per call.",
  "assistant.email": "E-mail",
  "assistant.emailHint":
    "Replies to e-mails go to your own inbox. To let the assistant read replies, forward them to the e-mail webhook (needs a small forwarder; see docs/ASSISTANT.md).",
  "assistant.callTitle": "Call with the assistant",
  "assistant.answer": "Answer the call",
  "assistant.ch.app": "In-app message",
  "assistant.ch.appcall": "📞 In-app voice call",
  "assistant.ch.email": "E-mail",
  "assistant.ch.sms": "SMS",
  "assistant.ch.whatsapp": "WhatsApp",
  "assistant.ch.call": "Real phone call",
  "call.title": "Call",
  "call.ringing": "Ringing…",
  "call.connecting": "Connecting…",
  "call.ended": "Call ended",
  "call.hangup": "Hang up",
  "call.incoming": "Incoming call",
  "call.assistantOf": "{name}'s assistant",
  "call.assistantCalling": "Assistant call",
  "popup.thinking": "The assistant is replying…",
  "popup.quick.free": "Yes, I'm free",
  "popup.quick.later": "Give me a few minutes",
  "popup.quick.busy": "I'm busy right now",
  "call.answer": "Answer",
  "call.decline": "Decline",
  "call.declined": "Declined",
  "call.noAnswer": "No answer",
  "call.failed": "The connection failed (a strict firewall may be blocking direct audio).",
  "call.micDenied": "Microphone permission is needed to call.",
  "call.callBtn": "Call",
} as const;

export type Key = keyof typeof en;
